<template>
    <div class="as-serviceitem_advanced_selector">
        <mock-el-select
			slot="reference"
			size="small"
            :focus="dialogVisible"
            :multiple="multiple"
			:tag-list="selectViewData"
            :placeholder="placeholder"
            :collapseTags="true"
            :clearable="true"
			:props="{label: 'name', id: 'no'}"
			@close="handleTagClose"
            @clear="handleTagClear"
			@click.native="onShowDialog"
            :wordNumber="18">
		</mock-el-select>
        <as-serviceitem-dialog-selector
            ref="dialogSelector"
            v-on="$listeners"
            v-bind="$attrs"
            v-model="dialogVisible"
            :selectId="checkedKeys[0]"
            :multiple="multiple"
            :showTimes="showTimes"
            :loading="dialogLoading"
            :group-data="selectorData"
            :sidebar-list="sidebarData"
            :default-checked-keys="checkedKeys"
            @on-confirm="onConfirm"
            @on-select-item="onSelectItem">
        </as-serviceitem-dialog-selector>
    </div>
</template>

<script>
    import MockElSelect from '@/components/mock-el-select'
    import AsServiceitemDialogSelector from '@/components/serviceitem-dialog-selector'
    import AdvancedSelector from '@/components/advanced-selector'
    export default {
        extends: AdvancedSelector,
        name: 'AsServiceitemAdvancedSelector',
        components: {
            MockElSelect,
            AsServiceitemDialogSelector,
        },
        props: {
            multiple: Boolean,
            showTimes: Boolean,
            filterMethod: Function,
            defaultSelectView: {
                type: String,
                default: '',
            }
        },
        computed: {
            checkedKeys() {
                const idList = this.defaultCheckedKeys.length ? this.defaultCheckedKeys : (this.selectListData ? this.selectListData.map(item => item.no) : []);
                return  idList;
            },
            selectViewData() {
                return this.selectListData || this.defaultSelectViewData;
            },
        },
        methods: {
            handleTagClear() {
                this.selectListData = [];
                this.triggerEvent(this.selectListData);
            },
            handleTagClose(index) {
                this.selectListData.splice(index, 1);
                this.triggerEvent(this.selectListData);
            },
            loadDataCallback(serviceItemList) {
                const listData = serviceItemList.filter(classItem => {
                    const { serviceItems, classid } = classItem;
                    if (serviceItems && serviceItems.length) {
                        classItem.serviceItems = serviceItems.map(item => {
                            item.classid = classid;
                            return item;
                        })
                    }
                    classItem.itemid = classid;
                    return classItem.serviceItems && classItem.serviceItems.length
                });
                const sidebarListData = [{
                    itemid: -1,
                    name: '全部',
                    classid: -1,
                }, ...listData];
                this.dialogLoading = false;
                this.loadSelectorData = listData;
                this.loadSidebarData = sidebarListData;
            },
        }
    }
</script>
<style lang="scss">
.as-serviceitem_advanced_selector {
    display: inline-flex;
}
</style>